<div class="flex flex-wrap gap-2">
  <ng-container *ngFor="let htmlLabel of state.labels; trackBy: trackByValue; let idx = index">
    <div class="flex items-center gap-0.5" [innerHTML]="htmlLabel"></div>
    <div *ngIf="idx < state.labels.length - 1" class="separator">or</div>
  </ng-container>
</div>
